import api from './api'

const resource = '/statistic'

export default {
	
	getTestsCount() {
		return api.get(`${resource}`)
	},
}